import Portfolio from "./components/Portfolio";
import React from "react";

function App() {
  return (
    <div className="App">
      <Portfolio/>
    </div>
  );
}

export default App;
